import React from 'react'

import Services from '../Services/Services'
import Welcome from '../Welcome/Welcome'
import Hello from "../Hello/Hello"
import Serve from '../Serve/Serve'
import Why from '../Why/Why'
import Testimonials from '../Testimonials/Testimonials'
import Newsletter from '../Newsletter/Newsletter'
import ConnectSection from '../Connect/Connect'
import FirstPost from '../FirstPost/FirstPost'
import Event from '../Event/Event'
import Event2 from '../Event/Event2'
import Popup from '../Popup/Popup'
const Home = () => {
  return (
    <>
        
   <FirstPost/>
   <Popup/>
   <Event/>
   <Event2/>
   <Services/>
   <Welcome/>
   <Hello/>
   <Serve/>
   <Why/>
   <Testimonials/>
   <Newsletter/>
   <ConnectSection/>
 
    </>
  )
}

export default Home